// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"443":"about","767":"details","913":"post"}[chunkId] || chunkId) + "." + {"443":"dc590a00","549":"d2500f87","767":"ad2d478b","913":"7f8253a4"}[chunkId] + ".js";
};